import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { CreditScoreArrayGateway } from '@domain/models/credit-score-array/gateway/credit-score-array.gateway';
import {
  ArrayVerificationOutcome,
  ICreditScoreConfig,
  ICreditScoreStatus,
  ICreditScoreUserToken,
  IStartAttemptResponse,
} from '@domain/interfaces/credit-score-array/credit-score-array.interface';

@Injectable({
  providedIn: 'root',
})
export class CreditScoreArrayService extends CreditScoreArrayGateway {
  constructor(private _http: HttpClient) {
    super();
  }

  private get baseUrl(): string {
    return `${environment.memberPortalServiceURL.replace('{{brandDomain}}', window.location.host)}/creditscore`;
  }

  getStatus(): Observable<ICreditScoreStatus> {
    return this._http.get<ICreditScoreStatus>(`${this.baseUrl}/status`);
  }

  getConfig(): Observable<ICreditScoreConfig> {
    return this._http.get<ICreditScoreConfig>(`${this.baseUrl}/config`);
  }

  startAttempt(): Observable<IStartAttemptResponse> {
    return this._http.post<IStartAttemptResponse>(`${this.baseUrl}/attempts`, {});
  }

  reportOutcome(attemptId: number, event: ArrayVerificationOutcome, legIndex?: number, sectionName?: string): Observable<IStartAttemptResponse> {
    return this._http.post<IStartAttemptResponse>(`${this.baseUrl}/attempts/${attemptId}/outcome`, { event, legIndex, sectionName });
  }

  confirmEnrollment(): Observable<ICreditScoreStatus> {
    return this._http.post<ICreditScoreStatus>(`${this.baseUrl}/enrollment`, {});
  }

  resetProfile(): Observable<ICreditScoreStatus> {
    return this._http.post<ICreditScoreStatus>(`${this.baseUrl}/enrollment/reset`, {});
  }

  getUserToken(): Observable<ICreditScoreUserToken> {
    return this._http.post<ICreditScoreUserToken>(`${this.baseUrl}/token`, {});
  }
}
